<template>
	<div style="height:100%;max-width: 750px;">
		<transition  mode="out-in">
				<router-view  v-if="!$route.params.isAlive && IsRouterAlive" :class="{'child-view': !$route.meta.keepAlive && $route.meta.showAnimation}"></router-view>
		</transition>
		<keep-alive>
			<router-view v-if="$route.params.isAlive && IsRouterAlive"></router-view>
		</keep-alive>

	</div>
</template>

<script>
import router from './router';
// import nav from './components/nav/m-nav';
import { setSessionStore, getSessionStore } from '@/common/js/sessionStorage';
import { fetch } from '@/common/js/fetch';
import { getEmpInfo } from '@/common/js/succestechApi.js';
import { getWXConfig } from '@/common/js/getWXConfig.js';

export default {
  components: {

  },
  provide() {
      return {
        reload: this.reload   // 向所有子组件暴露一个方法用于刷新当前页面
      }
  },
  data() {
    return {
        IsRouterAlive: true
    }
  },
  created() {

  },
    mounted() {
        // H5在ios弹窗状态下调起输入法后关闭输入法页面元素错位解决办法
        document.body.addEventListener('focusout', () => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        })
    },
  methods: {
    reload() {
        this.IsRouterAlive = false;
        this.$nextTick(function() {
            this.IsRouterAlive = true;
        })
    }

  },
  watch: {
      '$route' (to, from) {
          // 判断是否显示调试按钮
          if (to.query.vConsole == 1) {
              var vConsole = new VConsole();
          }
       }
	}
};
</script>

<style lang="less">
@import './common/style/iconfont.css';
@import "./common/style/publicClass.less";
</style>



// WEBPACK FOOTER //
// src/App.vue